import {Fragment} from 'react'
import {useForm, FormProvider, Controller} from 'react-hook-form'
import PropTypes from 'prop-types'
import {Link} from 'react-router'

import {FormControlLabel, Radio, RadioGroup, FormHelperText} from '@mui/material'

import {Button} from '../../../../dashboard/src/components/blocks/Buttons'
import TfaSignInFrame from './TfaSignInFrame'
import MixpanelLogger from '../../../../lib/MixpanelLogger'


const OtpDeliverySelection = props => {
  const methods = useForm()

  const onSubmit = data => {
    props.selectDeliveryOption(data.delivery)
  }

  return (
    <TfaSignInFrame
      className='otp-delivery-selection'
      heading='Verify your identity'
      subtitle={`Choose the method of how we deliver the 6-digit code to ${props.obfuscatedPhoneNumber}`}
      footer={
        <Fragment>
          <Button className='submit' onClick={methods.handleSubmit(onSubmit)}>Send code</Button>
          <Link to='/auth/sign_in/tfa_alternatives' className='alternative-method' onClick={() => MixpanelLogger.track('2fa_try_different_method')}>Try a different method</Link>
        </Fragment>
      }>
      <Fragment>
        <h5>Delivery method</h5>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <Controller
              name='delivery'
              control={methods.control}
              defaultValue='text'
              render={({field}) => (
                <RadioGroup {...field} aria-labelledby='radio-buttons-group'>
                  <Fragment>
                    <FormControlLabel
                      value='text'
                      control={<Radio />}
                      label='Text message (SMS)'
                    />
                    <FormHelperText>Receive a code via text message</FormHelperText>
                  </Fragment>
                  <Fragment>
                    <FormControlLabel
                      value='voice'
                      control={<Radio />}
                      label='Phone call (Voice)'
                    />
                    <FormHelperText>Receive a code via automated call</FormHelperText>
                  </Fragment>
                </RadioGroup>
              )}
            />
          </form>
        </FormProvider>
      </Fragment>
    </TfaSignInFrame>
  )
}

OtpDeliverySelection.propTypes = {
  obfuscatedPhoneNumber: PropTypes.string.isRequired,
  selectDeliveryOption: PropTypes.func.isRequired
}

export default OtpDeliverySelection
